<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_vii"></a>CONTENTS</h2>
<p class="toc-chapter"><em><a class="nounder" href="#/xhtml/ack#ack">Acknowledgments</a></em></p>
<p class="toc-chapter"><a class="nounder" href="#/xhtml/introduction">Introduction</a></p>
<p class="toc-chapter"><a class="nounder" href="#/xhtml/ch01">1 Of Birds, Figs, and Sexual Identity in the Renaissance, or The Marescalco’s Boy Bride</a></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/ch02" title="Link target outside of Sample">2 Playing with the Devil: The Pleasures and Dangers of Sex and Play</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">3 The Abbot’s Concubine: Renaissance Lies, Literature, and Power</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">4 Brunelleschi’s First Masterpiece, or Mean Streets, Familiar Streets, Masculine Spaces, and Identity in Renaissance Florence</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">5 Machiavelli in Love: The Self-Presentation of an Aging Lover</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">6 Death and Resurrection and the Regime of <em>Virtù,</em> or Of Princes, Lovers, and Prickly Pears</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample">Afterword. How Machiavelli Put the Devil Back in Hell</span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/bibliography" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc-chapter"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample"><em>Index</em></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?f45f524e